import { getCookie } from '@utiljs/cookie';

let wmPoiId = '';
let wmPoiName = '';
let onlyForDaodianAcct = '';
let scIndex = '';
/**
 * 获取外卖门店ID
 */
export function getWmPoiId(): string {
    if (wmPoiId === '') {
        wmPoiId = getCookie('wmPoiId');
    }
    return wmPoiId;
}

/**
 * 获取外卖门店名称
 */
export function getWmPoiName(): string {
    if (wmPoiName === '') {
        wmPoiName = getCookie('wmPoiName') || '全部门店';
    }
    return wmPoiName;
}

let acctId = '';

/**
 * 获取账号ID
 */
export function getAcctId() {
    if (acctId === '') {
        acctId = getCookie('acctId');
    }
    return acctId;
}

let deviceId = '';

/**
 * 获取设备ID
 */
export function getDeviceId() {
    if (deviceId === '') {
        deviceId = getCookie('device_uuid');
    }
    return deviceId;
}

let token = '';

/**
 * 获取token
 */
export function getToken() {
    if (token === '') {
        token = getCookie('token');
    }
    return token;
}

/**
 * 获取外卖门店是否是仅到店门店
 */
export function getOnlyForDaoDianAcct() {
    if (onlyForDaodianAcct === '') {
        onlyForDaodianAcct = getCookie('onlyForDaoDianAcct');
    }
    return onlyForDaodianAcct;
}

interface IPoi {
    /**
     * 状态
     */
    status: number;
    /**
     * poi名称
     */
    poiName: string;
    /**
     * 门店id
     */
    id: number;
}

let poiList: IPoi[] = [];
/**
 * 获取本地的POI信息，
 */
export function getLocalPoiList() {
    if (poiList.length === 0) {
        // eslint-disable-next-line waimaie/no-direct-access-localstorage
        const poiListStr = window.localStorage.getItem('localAllPoiList') || '';
        if (poiListStr !== '') {
            poiList = JSON.parse(poiListStr);
        }
    }
    return poiList;
}

/**
 * 判断单\多店
 */
export function isMultiPoi(): boolean {
    if (getWmPoiId() === '-1') return true;
    return false;
}

let poiIds: number[] = [];

/** 获取账号下的所有门店的门店id */
export function getLocalPoiIds() {
    if (poiIds.length === 0) {
        try {
            // eslint-disable-next-line waimaie/no-direct-access-localstorage
            poiIds = JSON.parse(window.localStorage.getItem('localALLPoiIds') || '[]');
            // 后续将都是用localAllpoiids，所以将删除下方代码
            if (poiIds.length === 0) {
                // eslint-disable-next-line waimaie/no-direct-access-localstorage
                poiIds = JSON.parse(window.localStorage.getItem('localAllPoiList') || '[]').map(
                    (item: IPoi) => item.id,
                );
            }
        } catch (e) {
            // JSON.parse error
        }
    }
    return poiIds;
}

/** 判断总店 & 多门店 */
export function isHeadMultiPoi() {
    // isChain=1代表多店账号
    // eslint-disable-next-line waimaie/no-direct-access-localstorage
    return isMultiPoi() && localStorage.getItem('isChain') === '1';
}

/**
 * 获取scIndex
 */
export function getscIndex() {
    if (scIndex === '') {
        scIndex = `${getCookie('scIndex')}`;
    }
    return scIndex;
}
